export default class SingleScheduleParticipant {
    constructor(participantData) {
        this.id = participantData?.id ?? null;
        this.first_name = participantData.first_name;
        this.last_name = participantData.last_name;
        this.short_club_name = participantData.short_club_name;
        this.club_id = participantData?.club_id ?? null;
    }
}

//SPAN = 12 TOTAL
export const ParticipantTableColumns = [
    { columnKey: "participant", label: "Participant", span: 10 },
    { columnKey: "actions", label: "Actions", span: 2 },
]